module.exports = __webpack_public_path__ + "static/media/badges.dc6ca298.png";